module.exports = __webpack_public_path__ + "static/media/box_internet.e134177f.svg";